<div id="card-tasks">
  <dx-data-grid
    *ngIf="currentTasks"
    #dataGrid
    [dataSource]="currentTasks"
    [columnAutoWidth]="true"
  >
    <dxo-data-grid-selection mode="multiple" showCheckBoxesMode="always"></dxo-data-grid-selection>

    <dxo-data-grid-row-dragging
      [allowReordering]="true"
      [onReorder]="onReorder"
      [showDragIcons]="true"
    ></dxo-data-grid-row-dragging>

    <dxi-data-grid-column
      dataField="text"
      [caption]="'crmContacts.cols.subject' | translate"
      [hidingPriority]="3"
    ></dxi-data-grid-column>
    <dxi-data-grid-column
      dataField="date"
      dataType="date"
      [caption]="'crmContacts.cols.dueDate' | translate"
      [hidingPriority]="1"
    ></dxi-data-grid-column>
    <dxi-data-grid-column
      [caption]="'crmContacts.cols.assignedTo' | translate"
      dataField="manager"
      [hidingPriority]="0"
    ></dxi-data-grid-column>
  </dx-data-grid>

  <dx-load-panel
    [visible]="!currentTasks || isLoading"
    [showPane]="false"
    container="#card-tasks"
    [position]="{ of: '#card-tasks' }"
  ></dx-load-panel>
</div>
